import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import {IntlProvider, addLocaleData} from 'react-intl'
import Utils from './Utils'

import cs from 'react-intl/locale-data/cs'
import de from 'react-intl/locale-data/de'
import en from 'react-intl/locale-data/en'
import fi from 'react-intl/locale-data/fi'
import fr from 'react-intl/locale-data/fr'
import it from 'react-intl/locale-data/it'
import ja from 'react-intl/locale-data/ja'
import ko from 'react-intl/locale-data/ko'
import lt from 'react-intl/locale-data/lt'
import nb from 'react-intl/locale-data/nb'
import nl from 'react-intl/locale-data/nl'
import pl from 'react-intl/locale-data/pl'
import ru from 'react-intl/locale-data/ru'
import sv from 'react-intl/locale-data/sv'
import uk from 'react-intl/locale-data/uk'

import csMsg from './lang/csMsg'
import deMsg from './lang/deMsg'
import enMsg from './lang/enMsg'
import fiMsg from './lang/fiMsg'
import frMsg from './lang/frMsg'
import itMsg from './lang/itMsg'
import jaMsg from './lang/jaMsg'
import koMsg from './lang/koMsg'
import ltMsg from './lang/ltMsg'
import nbMsg from './lang/nbMsg'
import nlMsg from './lang/nlMsg'
import plMsg from './lang/plMsg'
import ruMsg from './lang/ruMsg'
import svMsg from './lang/svMsg'
import ukMsg from './lang/ukMsg'

addLocaleData([
  ...cs,
  ...de,
  ...en,
  ...fi,
  ...fr,
  ...it,
  ...ja,
  ...ko,
  ...lt,
  ...nb,
  ...nl,
  ...pl,
  ...ru,
  ...sv,
  ...uk
]);

var params = Utils.hashToMap()

var msg = enMsg
if (params.lang === "cs") {
  msg = csMsg
} else if (params.lang === "de") {
  msg = deMsg
} else if (params.lang === "fi") {
  msg = fiMsg
} else if (params.lang === "fr") {
  msg = frMsg
} else if (params.lang === "it") {
  msg = itMsg
} else if (params.lang === "ja") {
  msg = jaMsg
} else if (params.lang === "ko") {
  msg = koMsg
} else if (params.lang === "lt") {
  msg = ltMsg
} else if (params.lang === "nb") {
  msg = nbMsg
} else if (params.lang === "nl") {
  msg = nlMsg
} else if (params.lang === "pl") {
  msg = plMsg
} else if (params.lang === "ru") {
  msg = ruMsg
} else if (params.lang === "sv") {
  msg = svMsg
} else if (params.lang === "uk") {
  msg = ukMsg
} else {
  msg = enMsg
  params.lang = 'en'
}

const muiTheme = getMuiTheme({
  fontFamily: "OpenSans Regular",
  palette: {
    primary1Color: '#E06B37'
  }
})

ReactDOM.render(
  <IntlProvider locale={params.lang} messages={msg}>
    <MuiThemeProvider muiTheme={muiTheme}><App/></MuiThemeProvider>
  </IntlProvider>,
  document.getElementById(
    'root'
  )
);



// WEBPACK FOOTER //
// ./src/index.js